import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useEditTrainingContext } from 'modules/trainings/hooks/EditTraining/useEditTrainingContext'

const CourseValidityUnCheckModal = ({ setOpen }: { setOpen?: (value: boolean) => void }) => {
  const { setCourseValidityToggle, courseValidityToggle } = useEditTrainingContext()

  return (
    <Modal
      title={i18n.t('trainings.edit_mode.basic_information.course_validity_modal.title')}
      description={i18n.t(
        'trainings.edit_mode.basic_information.course_validity_modal.description'
      )}
      onClose={() => {
        if (setOpen) setOpen(false)
        setCourseValidityToggle(!courseValidityToggle)
      }}
      onSubmit={() => {
        if (setOpen) setOpen(false)
        setCourseValidityToggle(false)
      }}
      illustration="document-edit"
      footer={
        <Box flexDirection="row" gap="s8">
          <Button
            onClick={() => {
              if (setOpen) setOpen(false)
              setCourseValidityToggle(true)
            }}
            type="secondary"
          >
            {i18n.t('trainings.edit_mode.basic_information.course_validity_modal.cancel')}
          </Button>
          <Button submit>
            {i18n.t('trainings.edit_mode.basic_information.course_validity_modal.submit')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}
export default CourseValidityUnCheckModal
